import React from 'react';
import GenericApprovalSection from './GenericApprovalSection';
import { ResourceRequest } from '../../hooks/incidentResourceRequestHooks';
import { ApprovalStage } from '../utils/ResourceRequestTypes';

interface FinanceApprovalSectionProps {
  requestData: ResourceRequest | null;
  currentStage: ApprovalStage;
  onApprove: () => void;
  isSubmitting: boolean;
  isCompleted: boolean;
}

const FinanceApprovalSection: React.FC<FinanceApprovalSectionProps> = ({
  requestData,
  currentStage,
  onApprove,
  isSubmitting,
  isCompleted,
}) => {
  return (
    <GenericApprovalSection
      stage="finance"
      requestData={requestData}
      currentStage={currentStage}
      onApprove={onApprove}
      isSubmitting={isSubmitting}
      isCompleted={isCompleted}
      nameField="finance_name"
      positionField="finance_position"
      commentsField="finance_comments"
      signatureField="finance_signature"
      timestampField="finance_signature_timestamp"
    />
  );
};

export default FinanceApprovalSection;
